import { ListingsBenchmarkTopListingsActionTypes } from './constants';

/**
 * @param {import('../reducer.initialData').ListingsBenchmarkTopListingsResponse} response
 * @returns {{type: string, result: import('../reducer.initialData').ListingsBenchmarkTopListingsResponse,  currentLevel: import('../../../../../shared/modules/dealersInsights/redux/level/reducer.defaultState').DealerInsightsLevel, currentDealerId: string}}
 */

export const getListingsBenchmarkTopListingsDataSuccess = ({
  result,
  currentLevel,
  currentDealerId,
}) => ({
  type: ListingsBenchmarkTopListingsActionTypes.GET_TOP_LISTINGS_DATA_SUCCESS,
  result,
  currentLevel,
  currentDealerId,
});

/**
 * @param {any} error
 * @returns {{type: string, error: any}}
 */
export const getListingsBenchmarkTopListingsDataError = error => ({
  type: ListingsBenchmarkTopListingsActionTypes.GET_TOP_LISTINGS_DATA_ERROR,
  error,
});

/**
 * @param {import('../reducer.initialData').ListingsBenchmarkTopListingsCategory} category
 * @returns {{type: string, category: import('../reducer.initialData').ListingsBenchmarkTopListingsCategory}}
 */
export const setListingsBenchmarkActiveTopListingsCategory = category => ({
  type:
    ListingsBenchmarkTopListingsActionTypes.SET_ACTIVE_TOP_LISTINGS_CATEGORY,
  category,
});

/**
 * @returns {{type: string}}
 */
export const clickTopListingsCarTile = () => ({
  type: ListingsBenchmarkTopListingsActionTypes.CLICK_TOP_LISTINGS_CAR_TILE,
});

/**
 * @returns {{type: string}}
 */
export const toggleTopListingsCategoryDropdown = () => ({
  type: ListingsBenchmarkTopListingsActionTypes.TOGGLE_CATEGORY_DROPDOWN,
});
